import { Store } from 'pullstate';
import * as XLSX from 'xlsx';
import { Lead, Session } from './LeadDataGridStore';

export const importSchema = [
    { columnName: 'startDate', dataType: 'datetime', maxLength: 0, isSelect: false },
    { columnName: 'leadOwner', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'company', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'firstName', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'lastName', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'jobTitle', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'linkedIn', dataType: 'string', maxLength: 2000, isSelect: false },
    { columnName: 'leadLevel', dataType: 'string', maxLength: 2000, isSelect: false },
    { columnName: 'emailAddress', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'switchboard', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'phone', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'mobile', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'city', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'province', dataType: 'string', maxLength: 255, isSelect: false },
    { columnName: 'country', dataType: 'string', maxLength: 2000, isSelect: true },
    { columnName: 'leadSource', dataType: 'string', maxLength: 2000, isSelect: true },
    { columnName: 'leadFunction', dataType: 'string', maxLength: 2000, isSelect: true },
    { columnName: 'leadIndustry', dataType: 'string', maxLength: 2000, isSelect: true },
    { columnName: 'leadRegion', dataType: 'string', maxLength: 2000, isSelect: true },
    { columnName: 'leadCompanyRevenue', dataType: 'string', maxLength: 2000, isSelect: true },
] as ImportRowSchema[];

export type SheetError = {
    rowNum: number;
    colNum: number;
    message: string;
    errorType: 'warning' | 'error';
};

export type ImportRowSchema = {
    [x: string]: any;
    columnName: string;
    mappedField?: string;
    isSelect: boolean;
    dataType: 'int' | 'string' | 'datetime' | 'bool';
    maxLength: number;
    displayName?: string;
    required?: boolean;
};

const ExcelImportStore = new Store({
    workbook: null as null | XLSX.WorkBook,
    revalidate: false,
    worksheet: null as null | XLSX.WorkSheet,
    errors: [] as SheetError[],
    unmappedColumns: [] as string[],
    mapSchema: [] as ImportRowSchema[],
    loaded: false,
    allColumns: [] as string[],
    leads: [] as Lead[],
    step: 0,
    session: {
        importType: 'ImportToSprint',
        name: '',
        sessionId: crypto.randomUUID(),
    } as Session,
    fileError: false,
});

export default ExcelImportStore;
